import { WistiaVideo } from 'features/help/types/wistiaVideo';

type VideoPlayerProps = {
  wistiaData: WistiaVideo;
  autoplay?: boolean;
  videoFoam?: boolean;
};

const VideoPlayer = ({ wistiaData, autoplay = true, videoFoam = true }: VideoPlayerProps) => {
  const hashedId = wistiaData.items[0]?.hashed_id;

  if (!hashedId) {
    console.warn('Wistia video data missing hashed_id');
    return null;
  }

  const params = new URLSearchParams({
    seo: 'true',
    videoFoam: String(videoFoam),
    autoPlay: String(autoplay),
    playerColor: '54bbff',
  });

  const src = `https://fast.wistia.net/embed/iframe/${hashedId}?${params.toString()}`;

  return (
    <div style={{ width: '75%' }}>
      <iframe
        src={src}
        title="Wistia video player"
        allow="autoplay; fullscreen"
        allowFullScreen
        className="wistia_embed"
        name="wistia_embed"
        style={{
          width: '100%',
          aspectRatio: '16 / 9',
          border: 0,
        }}
      />
    </div>
  );
};

export default VideoPlayer;
